import { useMemo, useState } from 'react';

import { useResource } from '@atlassian/eoc-rrr-helpers';

import { useAutoCreateService } from '../../services/auto-create';
import { heartbeatsResource } from '../../services/resources';

export const useAutoCreateController = () => {
	const { isAutoCreateUpdating, updateAutoCreation } = useAutoCreateService();
	const { data, update } = useResource(heartbeatsResource);

	const [isUpdateAutoCreationModalOpen, setUpdateAutoCreationModalOpen] = useState(false);

	const isAutoCreateEnabled = useMemo(() => !!data?.autoCreateEnabled, [data?.autoCreateEnabled]);

	const handleUpdateAutoCreationClick = () => {
		setUpdateAutoCreationModalOpen(true);
	};

	const handleCloseUpdateAutoCreationModal = () => {
		setUpdateAutoCreationModalOpen(false);
	};

	const handleUpdateAutoCreation = () => {
		handleCloseUpdateAutoCreationModal();

		return updateAutoCreation(!isAutoCreateEnabled)
			.then(() => {
				update((state) => ({
					...state!,
					autoCreateEnabled: !isAutoCreateEnabled,
				}));
			})
			.catch(() => {});
	};

	return {
		isAutoCreateEnabled,
		isAutoCreateUpdating,
		isUpdateAutoCreationModalOpen,
		handleUpdateAutoCreation,
		handleUpdateAutoCreationClick,
		handleCloseUpdateAutoCreationModal,
	};
};
